import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Link} from 'react-router-dom';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ProductUnitTableRow from '../components/ProductUnitTableRow';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FuseTheme from "../global/theme";

/**
 * A component for generating rows of ProductUnitTableRows.
 *
 */
class ProductUnitTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            needDefaultUnit: false,
            productId: '',
            productType: '',
            productUnitList: {},
        };
    }

    componentWillMount() {
        this.setState({
            productId: this.props.productId,
            productType: this.props.productType
        });
        this.fetchProductUnits();
    }

    getBasePathUpOne() {
        return this.props.basePath
            .split('/')
            .slice(0, -2)
            .join('/');
    }

    // Get all Product Units for this Product
    fetchProductUnits() {
        const params = {
            filter: {
                type: this.props.productType,
                id: this.props.productId
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductUnitsByTypeProductId.GET_LIST(params);

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        const payload = result.data.payload;
                        this.setState({
                            productUnitList: payload
                        });
                        this.checkForDefault(payload);
                    } else {
                        this.setState({
                            dialogOpen: true,
                            needDefaultUnit: true
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    this.setState({
                        dialogOpen: true,
                        needDefaultUnit: true
                    });
                });
            });
    }

    /**
     * Check if this Product has a default Product Unit
     *
     * @param list
     */
    checkForDefault = (list) => {
        let idx = list.findIndex(listItem => listItem.default_unit === true);
        if (idx === -1) {
            this.setState({
                dialogOpen: true,
                needDefaultUnit: true
            });
        }
    };

    // Create table rows of Product Unit items
    makeProductUnitTable = (list, showEdit, showView) => {
        if (!list || !list.length) {
            return (
                <TableRow>
                    <TableRowColumn>No Product Units</TableRowColumn>
                    <TableRowColumn>&nbsp;</TableRowColumn>
                    <TableRowColumn>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <ProductUnitTableRow
                    key={item.id.toString() + index}
                    basePath="/ProductUnits"
                    data={item}
                    showDelete={false}
                    showEdit={showEdit}
                    showView={showView}
                />
            ))
        )
    };

    handleDialogClose = () => {
        this.setState({dialogOpen: false});
    };

    render() {
        const styles = {
            dialogContent: {maxWidth: 500, textAlign: 'center'},
            dialogButton: {margin: '0 8px'},
            fieldInstructions: {
                display: 'block',
                width: '100%',
                fontSize: '16px',
                lineHeight: '1.3',
                margin: '0 0 1em 0',
            },
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            tableCard: {display: 'block', margin: '1em 0 0 0'},
        };

        const basePath = this.getBasePathUpOne();

        return (
            <div>
                <Card style={styles.tableCard} initiallyExpanded>
                    <CardHeader title="Product Units" actAsExpander={true} showExpandableButton={true}/>
                    <CardText expandable={true}>
                        {!this.props.showCreate && !this.state.needDefaultUnit &&
                        <span style={styles.fieldDescription}>Product Units for this Product.</span>
                        }
                        {this.state.needDefaultUnit &&
                        <span style={styles.fieldDescription}>A Product must have a default Product Unit. Please create
                        a Product Unit Piece and set it as the default Unit.</span>
                        }
                        {this.props.productView === 'edit' &&
                        <span style={styles.fieldDescription}>To add or edit Product Units, click
                        the <strong>Show</strong> button.</span>
                        }
                        {this.props.productView !== 'edit' && this.state.needDefaultUnit &&
                        <span style={styles.fieldDescription}>Clicking the Add button will take you to a Product Unit
                        form.</span>
                        }
                        {this.props.showCreate && this.props.showEdit && !this.state.needDefaultUnit &&
                        <span style={styles.fieldDescription}>Add, View or Edit Product Units for this Product. Viewing or
                        Editing a Product Unit will take you to that Product Unit. Clicking the Add button will take
                        you to a Product Unit form.</span>
                        }
                        {this.props.showCreate && !this.props.showEdit &&
                        <span style={styles.fieldDescription}>Add Product Units for this Product. Clicking the Add
                        button will take you to a Product Unit form for this Product.</span>
                        }
                        <Table selectable={false} multiSelectable={false}>
                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                <TableRow>
                                    <TableHeaderColumn>Barcode</TableHeaderColumn>
                                    <TableHeaderColumn>Name</TableHeaderColumn>
                                    <TableHeaderColumn>Unit Type</TableHeaderColumn>
                                    <TableHeaderColumn>Price</TableHeaderColumn>
                                    {this.props.showView &&
                                    <TableHeaderColumn>View</TableHeaderColumn>
                                    }
                                    {this.props.showEdit &&
                                    <TableHeaderColumn>Edit</TableHeaderColumn>
                                    }
                                    {this.props.showDelete &&
                                    <TableHeaderColumn>Delete</TableHeaderColumn>
                                    }
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false}>
                                {[...this.makeProductUnitTable(this.state.productUnitList, this.props.showEdit, this.props.showView)]}
                            </TableBody>
                        </Table>
                        {this.props.showCreate &&
                        <div>
                            <FlatButton
                                primary
                                label="Add a Product Unit"
                                icon={<ContentAdd/>}
                                containerElement={<Link
                                    to={`${basePath}/ProductUnits/${this.props.productType}/${this.props.productId}/create`}/>}
                            />
                        </div>
                        }
                    </CardText>
                </Card>
                <Dialog
                    modal={false}
                    open={this.state.dialogOpen}
                    onRequestClose={this.handleDialogClose}
                    contentStyle={styles.dialogContent}
                >
                    <div style={styles.dialogContent}>
                        <p style={styles.fieldInstructions}>A Product must have at least one Product Unit Piece set as
                            its default Product Unit.</p>
                        <p style={styles.fieldInstructions}>To continue,
                            click the <strong>Add A Product Unit</strong> button or edit an existing Product Unit.</p>
                        <div>
                            <RaisedButton
                                type="button"
                                primary
                                label="Add a Product Unit"
                                icon={<ContentAdd/>}
                                containerElement={<Link
                                    to={`${basePath}/ProductUnits/${this.props.productType}/${this.props.productId}/create`}/>}
                                style={styles.dialogButton}
                            />
                            <FlatButton
                                type="button"
                                primary
                                onClick={this.handleDialogClose}
                                label="Cancel"
                                style={styles.dialogButton}
                            />
                        </div>
                    </div>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            productId: ownProps.productId,
            productType: ownProps.productType,
            productUnitList: ownProps.productUnitList,
            productView: ownProps.productView,
        }
    }
    return {}
};

ProductUnitTable.propTypes = {
    addField: PropTypes.bool,
    basePath: PropTypes.string,
    productId: PropTypes.string,
    productType: PropTypes.string,
    productUnitList: PropTypes.object,
    productView: PropTypes.string,
    showCreate: PropTypes.bool,
    showDelete: PropTypes.bool,
    showEdit: PropTypes.bool,
    showView: PropTypes.bool,
};

ProductUnitTable.defaultProps = {
    addField: true,
    productId: null,
    productType: null,
    productUnitList: {},
    productView: 'show',
    showCreate: false,
    showDelete: false,
    showEdit: false,
    showView: false,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ProductUnitTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitTable.js